import React from 'react';
import {classNames} from "@utils/class-names";

type Corner = 'nw' | 'ne' | 'sw' | 'se';

interface ResizeHandlesProps {
    onResizeMouseDown: (corner: Corner) => (e: React.MouseEvent) => void;
}

const HANDLES: Record<Corner, string> = {
    nw: '-top-1.5 -left-1.5 cursor-nw-resize',
    ne: '-top-1.5 -right-1.5 cursor-ne-resize',
    sw: '-bottom-1.5 -left-1.5 cursor-sw-resize',
    se: '-bottom-1.5 -right-1.5 cursor-se-resize',
};

const ResizeHandles: React.FC<ResizeHandlesProps> = ({onResizeMouseDown}) => (
    <>
        {(Object.keys(HANDLES) as Corner[]).map(corner => (
            <div
                key={corner}
                onMouseDown={onResizeMouseDown(corner)}
                className={classNames(
                    "absolute w-3 h-3 bg-white border-2 border-blue-500 rounded-full",
                    HANDLES[corner]
                )}
            />
        ))}
    </>
);

export default ResizeHandles;
